<template>
  <div class="disclaimer-bar">
    <div class="marquee">
      ⚠️ Этот сайт является тестовой версией для запуска города. Заказы не принимаются. Идёт проверка и отладка работы платформы.
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisclaimerBar'
}
</script>

<style scoped>
.disclaimer-bar {
  background-color: #e0e0e0; /* светло-серый фон */
  padding: 6px 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  position: relative;
  z-index: 1000;
}

.marquee {
  display: inline-block;
  white-space: nowrap;
  animation: marquee 15s linear infinite;
  padding-left: 100%;
}

@keyframes marquee {
  0%   { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}
</style>
